module.exports = __webpack_public_path__ + "img/animals_05_V.0ec68fac.jpg";